import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Home = () => import("../components/Home.vue");
const Login = () => import("../components/Login.vue");
const Clients = () => import("../components/Clients.vue");
const Client = () => import("../components/Client.vue");
const Project = () => import("../components/Project.vue");
const Room = () => import("../components/Room.vue");
const Measurement = () => import("../components/Measurement.vue");
const AnalysisAndAdvice = () => import("../components/AnalysisAndAdvice.vue");
const Products = () => import("../components/Products.vue");
const Admin = () => import("../components/Admin.vue");

export const router = new VueRouter({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/klanten",
      name: "Klanten",
      component: Clients,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/klant/:clientId",
      name: "Klant",
      component: Client,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/project/:projectId",
      name: "Project",
      component: Project,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ruimte/:roomId",
      name: "Ruimte",
      component: Room,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/meting/:measurementId",
      name: "Meting",
      component: Measurement,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/analyse-en-advies/:measurementId",
      name: "Analyse en advies",
      component: AnalysisAndAdvice,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/producten",
      name: "Producten",
      component: Products,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/router.js